import { Check } from 'lucide-react';

const STEPS = ['Your information', 'Review information', 'Engagement letter', 'Electronic signature', 'Completed'];

const indexFor = (status, consented) => {
  if (status === 'onboarding_completed') return 5;
  if (status === 'signed') return 4;
  if (status === 'partially_signed' || (status === 'awaiting_signature' && consented)) return 3;
  if (status === 'awaiting_signature') return 2;
  if (['ready_for_review', 'letter_generating', 'form_completed'].includes(status)) return 2;
  return 1;
};

export const EsignTracker = ({ status, consented }) => {
  const cur = indexFor(status, consented);
  return (
    <ol className="flex flex-wrap items-center gap-2 text-xs" data-testid="esign-tracker">
      {STEPS.map((s, i) => (
        <li key={s} className="flex items-center gap-2" data-testid={`esign-step-${i}`}>
          <span className={`flex h-6 w-6 items-center justify-center rounded-full border text-[11px] font-semibold ${i < cur ? 'border-emerald-500 bg-emerald-500 text-white' : i === cur ? 'border-primary text-primary' : 'text-muted-foreground'}`}>
            {i < cur ? <Check className="h-3.5 w-3.5" /> : i + 1}
          </span>
          <span className={i === cur ? 'font-semibold text-foreground' : 'text-muted-foreground'}>{s}</span>
          {i < STEPS.length - 1 && <span className="h-px w-6 bg-border" />}
        </li>
      ))}
    </ol>
  );
};
